import { render, staticRenderFns } from "./ManagePetition.vue?vue&type=template&id=3ec710b0&scoped=true&"
import script from "./ManagePetition.vue?vue&type=script&lang=js&"
export * from "./ManagePetition.vue?vue&type=script&lang=js&"
import style0 from "./ManagePetition.vue?vue&type=style&index=0&id=3ec710b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec710b0",
  null
  
)

export default component.exports